/**
 * Две буквы для кружка — из ПОЧТЫ.
 *
 * Берём первую букву до собаки и первую после разделителя, если он
 * есть: `artem.sokolov@` даёт «АС», `artem@` — «АR» не даёт, только «А».
 *
 * ПОЧТЫ НЕТ — КРУЖОК ПУСТ, а не со знаком вопроса: запись удалена,
 * и вопросительный знак читается как «мы не знаем», хотя мы знаем.
 *
 * ═══════════════════════════════════════════════════════════════════════
 * ОДИН РАСЧЁТ НА ТРИ ЭКРАНА, И ЭТО НЕ АККУРАТНОСТЬ РАДИ АККУРАТНОСТИ.
 *
 * Кружок стоит в трёх местах: в списке сотрудников, в шапке админки
 * (метка вошедшего) и — с пакета 25.08 — в шапке кабинета, кнопкой
 * профиля. Второй расчёт разошёлся бы с первым на первой же правке
 * разделителей, и один и тот же человек получил бы в списке «АС»,
 * а в шапке «А». Такое расхождение читается как «это разные люди»,
 * а не как «шрифт другой».
 *
 * ЛЕЖИТ В `ui/`, А НЕ В `admin/`: кабинет из админки не ввозит
 * ничего — это два разных приложения, склеенные одной сборкой,
 * и ввоз через границу однажды утащил бы за собой её половину.
 * ═══════════════════════════════════════════════════════════════════════
 */
export function инициалы(email: string | null): string {
  if (email === null) return '';
  const имя = email.split('@')[0] ?? '';
  const части = имя.split(/[.\-_+]/).filter((c) => c !== '');
  const буквы = части.slice(0, 2).map((c) => c[0]!.toUpperCase());
  return буквы.join('');
}

/**
 * ═══════════════════════════════════════════════════════════════════════
 * ДВЕ БУКВЫ ДЛЯ КРУЖКА СОТРУДНИКА: СНАЧАЛА ИМЯ, ПОТОМ ПОЧТА.
 *
 * До 26.08.2026 имени у сотрудника не было вовсе, и кружок собирался
 * из почты. На четырёх почтах одного домена — `artem@bidra.ru`,
 * `maria@bidra.ru`, `dmitry@bidra.ru`, `egor@bidra.ru` — он давал
 * «А», «М», «Д», «Е»: одну букву вместо двух и ни одной подсказки
 * о том, кто это.
 *
 * Эталон рисует «АС» — инициалы ИМЕНИ. Теперь имя есть, и кружок
 * берётся из него: «Артём Соколов» → «АС».
 *
 * ПОЧТА ОСТАЁТСЯ ЗАПАСНЫМ ПУТЁМ, а не выбрасывается: имя необязательно,
 * и у выдач до этой правки его нет. Пустой кружок там, где раньше была
 * буква, читался бы как поломка.
 * ═══════════════════════════════════════════════════════════════════════
 */
export function инициалыЧеловека(имя: string, email: string | null): string {
  const слова = имя.trim().split(/\s+/).filter((c) => c !== '');
  if (слова.length === 0) return инициалы(email);
  return слова
    .slice(0, 2)
    .map((c) => c[0]!.toUpperCase())
    .join('');
}
